import React, { ComponentPropsWithoutRef } from 'react';
import cn from 'classnames';

import SegmentTab from '../SegmentTab';

import './segmentControl.scss';

interface Props {
    tabs: ComponentPropsWithoutRef<typeof SegmentTab>[];
}

const SegmentControl: React.FC<Props> = ({ tabs }) => {
    return (
        <div
            styleName={cn('container', {
                'with-padding': tabs.length > 2,
            })}
        >
            {tabs.map(({ title, text, isActive, onClick }) => (
                <SegmentTab
                    key={text}
                    title={title}
                    text={text}
                    isActive={isActive}
                    onClick={onClick}
                />
            ))}
        </div>
    );
};

export default SegmentControl;
